export const SET_DRAWER_OPEN = 'uwave/mobile/SET_DRAWER_OPEN';
export const TOGGLE_DRAWER_OPEN = 'uwave/mobile/TOGGLE_DRAWER_OPEN';
export const SET_USERS_DRAWER_OPEN = 'uwave/mobile/SET_USERS_DRAWER_OPEN';
